
export default {
  props: {
    variant: {
      type: Object,
      required: true,
    },
  },
}
